import { SHIFTS } from "@/constants/shifts";
import hasPlural from "../hasPlural";
import { percentOf } from "../takenMath";

const pair = (shiftData) => ({
  ordered: (shiftData && shiftData.totalQuantity) || 0,
  taken: (shiftData && shiftData.totalQuantityPayed) || 0,
});

/**
 * Pakovanje / Preuzeti obroci firmi "više restorana" (telefon i računar): po firmi obroci (i sadržaj paketa kad
 * ga ima) po smenama kao poručeno / preuzeto, sa zbirom, posle pretrage (naziv obroka ili sadržaj). Zahteva
 * nasleđen stari tab more-restaurants/tabs/ReportMealsTabPackages (companies, selectedShifts, filters,
 * showCombination).
 */
export default {
  mixins: [hasPlural],
  computed: {
    isSingleDay() {
      return this.filters.dates.from === this.filters.dates.to;
    },
    /** Izabrane smene; četvrta samo kad neka firma u njoj ima obroke. */
    visibleShifts() {
      return SHIFTS.filter(
        (shift) =>
          this.selectedShifts.includes(shift.id) &&
          (shift.id < 4 ||
            this.companies.some((company) =>
              company.meals.some((meal) => (meal[shift.key] && meal[shift.key].totalQuantity) > 0)
            ))
      );
    },
    /** Firme sa obrocima posle pretrage (naziv obroka ili sadržaj), spremne za prikaz. */
    sections() {
      const search = this.toLatin(String(this.filters.search || "")).toLowerCase().trim();
      return this.companies
        .map((company, index) => {
          const meals = company.meals
            .filter(
              (meal) =>
                !search ||
                this.toLatin(`${meal.name || ""} ${meal.combination || ""}`).toLowerCase().includes(search)
            )
            .map((meal, mealIndex) => {
              const row = {
                key: `${meal.id}-${meal.combination || ""}-${mealIndex}`,
                name: this.toLatin(meal.name || ""),
                title: `${this.toLatin(meal.name || "")}${meal.id != null ? ` · ID ${meal.id}` : ""}`,
                combination: meal.combination ? this.toLatin(meal.combination) : "",
                total: meal.total || 0,
                totalPayed: meal.totalPayed || 0,
              };
              SHIFTS.forEach((shift) => {
                row[shift.key] = pair(meal[shift.key]);
              });
              return row;
            });
          // zbirovi samo za prikazane obroke i izabrane smene (kad nema pretrage isti kao u starom tabu)
          const totals = { total: 0, totalPayed: 0 };
          SHIFTS.forEach((shift) => {
            totals[shift.key] = meals.reduce(
              (sum, meal) => ({ ordered: sum.ordered + meal[shift.key].ordered, taken: sum.taken + meal[shift.key].taken }),
              { ordered: 0, taken: 0 }
            );
          });
          meals.forEach((meal) => {
            totals.total += meal.total;
            totals.totalPayed += meal.totalPayed;
          });
          const details = [
            { icon: "mdi-map-marker-outline", text: company.address },
            { icon: "mdi-phone-outline", text: company.phone },
            { icon: "mdi-city-variant-outline", text: company.city },
          ]
            .filter((detail) => detail.text)
            .map((detail) => ({ ...detail, text: this.toLatin(String(detail.text)) }));
          return {
            key: `${company.name}-${index}`,
            name: this.toLatin(company.name || ""),
            company,
            details,
            detailLine: details.map((detail) => detail.text).join(" · "),
            percent: percentOf(totals.totalPayed, totals.total),
            complete: totals.total > 0 && totals.totalPayed >= totals.total,
            rows: meals,
            totals,
            summary: `${this.pluralT("report_mobile.meals_n", totals.total)} · ${this.$t("taken")} ${totals.totalPayed}`,
          };
        })
        .filter((section) => section.rows.length || !search);
    },
    totals() {
      return this.sections.reduce(
        (sums, section) => ({ ordered: sums.ordered + section.totals.total, taken: sums.taken + section.totals.totalPayed }),
        { ordered: 0, taken: 0 }
      );
    },
    emptyTitle() {
      return this.filters.search
        ? this.$t("report_mobile.no_results_for", { search: this.filters.search })
        : this.$t("no_data");
    },
  },
  methods: {
    /** Preuzeto: sve (zeleno), deo (žuto), ništa (bez isticanja). */
    takenClass({ ordered, taken }) {
      if (!ordered || !taken) {
        return "";
      }
      return taken >= ordered ? "is-done" : "is-part";
    },
  },
};
